
<template>
	<div class="cache-dashboard">
		<b-navbar class="submenu">
			
		</b-navbar>
		<div class="container-fluid mt-4">
			<div v-if="stats">
				<div class="row">
					<div class="col-md-8">
						<div class="card p-3">
							<h5 class="mb-3">Cache Details</h5>
							<table class="table table-sm table-borderless mb-0 stats">
								<tbody>
									<tr>
										<th>Routed API Calls</th>
										<td>{{ stats.calls }}</td>
									</tr>
									<tr>
										<th>Flushes</th>
										<td>{{ stats.flushes }}</td>
									</tr>
									<tr>
										<th>Deletes</th>
										<td>{{ stats.deletes }}</td>
									</tr>
									<tr>
										<th>Queues</th>
										<td>{{ stats.queues }}</td>
									</tr>
									<tr>
										<th>Queue Processes</th>
										<td>{{ stats.queueProcesses }}</td>
									</tr>
									<tr>
										<th>Hits</th>
										<td>{{ stats.hits }}</td>
									</tr>
									<tr>
										<th>Queue Length</th>
										<td>{{ queueCount }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="card p-3 text-center mt-3">
							<b-row>
								<b-col>
									<b-input-group class="mb-2">
										<b-form-input
											v-model="flushUrl"
											placeholder="Flush a URL"
										></b-form-input>
										<b-input-group-append>
											<b-button variant="primary" @click="makeFlushRequest(flushUrl)">Flush</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<b-input-group class="mb-2">
										<b-form-input
											v-model="deleteUrl"
											placeholder="Delete a URL (supports *)"
										></b-form-input>
										<b-input-group-append>
											<b-button variant="primary" @click="makeDeleteRequest(deleteUrl)">Delete</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<b-button variant="primary" @click="log.unshift('----------------- MARK -----------------')">
										Mark
									</b-button>
									&nbsp;
								
									<b-button variant="primary" @click="processQueue()">
										Process Queue
									</b-button>
									&nbsp;

									<b-button variant="danger" :disabled="locked" @click="clearCache">
										Clear Cache
									</b-button>
									&nbsp;
									<!-- <b-form-checkbox v-model="showHeaders" class="ml-3">
										Show Remote Info
									</b-form-checkbox> -->
								</b-col>
							</b-row>
							
						</div>
					</div>
					<div class="col-md-4">
						<div class="card p-3 text-center">
							<h5>Hit Rate</h5>
							<div class="display-4 font-weight-bold text-success">{{stats.hits}} ({{ Number(stats.hitRate).toFixed(2) }})</div>
							<div class="text-muted2">Cache Efficiency</div>
						</div>
						<div class="card p-3 text-center mt-3">
							<h5>Misses</h5>
							<div class="display-4 font-weight-bold text-danger">{{ stats.misses }}</div>
							<div class="text-muted2">Excluding Flush Based</div>
						</div>
						<div class="card p-3 text-center mt-3">
							<b-button variant="danger" :disabled="locked" @click="clearStats">
								Reset Stats
							</b-button>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="text-center my-5">
				<b-spinner></b-spinner>
			</div>
			<div class="card mt-4">
				<div class="card-body">
					<b-row>
						<b-col>
							<b-form-input
								v-model="filterText"
								placeholder="Filter log entries..."
								class="mb-2"
							></b-form-input>
						</b-col>
						<b-col>
							<b-input-group class="mb-2">
								<b-form-input
									v-model="requestUrl"
									placeholder="Make a request to a URL"
								></b-form-input>
								<b-input-group-append>
									<b-button variant="primary" @click="makeRequest(requestUrl)">Go</b-button>
								</b-input-group-append>
							</b-input-group>
						</b-col>
					</b-row>
				</div>
			</div>
			<div class="card mt-4" style="background: #181a1b; color: #e5e5e5;">
				<div class="card-body">
					<h5 class="card-title mb-3">Cache Log</h5>
					<pre style="background: #181a1b; color: #ffffff; border-radius: 0.5rem; padding: 1rem; overflow-x: auto;">
<span v-for="(entry, idx) in filteredLog" :key="idx" v-html="highlightHit(entry)"></span>
					</pre>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Cache',
		data() {
			return {
				stats: null,
				log: [],
				interval: null,
				filterText: '',
				requestUrl: '',
				emptyRefreshes: 0,
				queueCount: 0,
				locked: true,
				showHeaders: true
			}
		},
	computed: {
		filteredLog() {
			if (!this.filterText) return this.log;
			const filter = this.filterText.toLowerCase();
			return this.log.filter(entry => entry.toLowerCase().includes(filter));
		}
	},
	methods: {
		getStats() {
			this.$http.get(this.$config.ApiUri + "/Cache/Stats")
				.then((result) => {
					this.stats = result.data;
				});
			this.$http.get(this.$config.ApiUri + "/Cache/RefreshQueue/Count")
				.then((result) => {
					this.queueCount = result.data;
				});
		},
		clearCache() {
			this.$http.delete(this.$config.ApiUri + "/Cache")
				.then((result) => {
					this.stats = result.data;
				});
		},
		clearStats() {
			this.$http.delete(this.$config.ApiUri + "/Cache/Stats")
				.then(() => {
					
				});
		},
		processQueue() {
			this.$http.post(this.$config.ApiUri + "/Cache/RefreshQueue/ProcessRequests")
				.then((result) => {
					this.stats = result.data;
				});
		},
		makeRequest(url) {
			this.$http.get(this.$config.ApiUri + "/Cached/" + url )
				.then((result) => {
					console.log(result.data);
					var json = JSON.stringify(result.data, null, 2);
					this.log.unshift(json);
				});
		},
		makeFlushRequest(url) {
			this.$http.put(this.$config.ApiUri + "/Cached/" + url )
				.then((result) => {
					console.log(result.data);
					var json = JSON.stringify(result.data, null, 2);
					this.log.unshift(json);
				});
		},
		makeDeleteRequest(url) {
			this.$http.delete(this.$config.ApiUri + "/Cached/" + url )
				.then((result) => {
					console.log(result.data);
					var json = JSON.stringify(result.data, null, 2);
					this.log.unshift(json);
				});
		},
		getLog() {
			this.$http.get(this.$config.ApiUri + "/Cache/Log")
				.then((result) => {
					const newEntries = result.data.filter(entry => !this.log.includes(entry));
					if (newEntries.length === 0) {
						this.emptyRefreshes++;
						if (this.emptyRefreshes == 7) {
							this.log.unshift('----------------- AUTO MARK -----------------');
						}
					} else {
						this.emptyRefreshes = 0; // Reset counter if new entries found
					}
					this.log = [...newEntries, ...this.log];
				});
		},
		onLoad() {
			this.getStats();
			this.getLog();
			this.interval = setInterval(() => {
				this.getStats();
				this.getLog();
			}, 3000);
		},
		highlightHit(entry) {
			return entry.replace(/\bHIT\b/g, '<span class="text-hit">HIT</span>')
			.replace(/----------------- MARK -----------------/g, '<span class="text-mark">----------------- MARK -----------------</span>')
			.replace(/----------------- AUTO MARK -----------------/g, '<span class="text-mark">----------------- AUTO MARK -----------------</span>')
			.replace(/\bMISS\b/g, '<span class="text-danger">MISS</span>')
			.replace(/\bPROCESS QUEUE\b/g, '<span class="text-process">PROCESS QUEUE</span>')
			.replace(/\bFLUSH\b/g, '<span class="text-warning">FLUSH</span>')
			.replace(/\bQUEUE\b/g, '<span class="text-queue">QUEUE</span>')
			.replace(/\bCLEARED ALL\b/g, '<span class="text-del">CLEARED ALL</span>')
			.replace(/\bCLEARED STATS\b/g, '<span class="text-success">CLEARED STATS</span>')
			.replace(/\bDELETE\b/g, '<span class="text-del">DELETE</span>')
			.replace(/\bEXCEPTION\b/g, '<span class="text-exception">EXCEPTION</span>')
			.replace(/\bSERVICE STARTED\b/g, '<span class="text-success">SERVICE STARTED</span>')
			.replace(/(https?:\/\/[^\s]+)/g, '<span class="text-info">$1</span>')
			//.replace(/(\/.*)/g, '<span class="text-info">$1</span>')
			.replace(/(.*\*.*)/g, '<span class="text-remoteinfo">$1</span>')
			.replace(/(took \d+\.?\d* ms)/g, '<span class="text-warning">$1</span>') + "<br/>";
		},
	},
	mounted() {
		this.onLoad();
		this.locked = this.$router.currentRoute.query.unlock !== 'true';
	},
	beforeDestroy() {
		if (this.interval) {
			clearInterval(this.interval);
		}
	}
}
</script>

<style scoped>
.cache-dashboard {
	background: #232a2f;
	min-height: 100vh;
	color: #e5e5e5 !important;
	font-family: 'Open Sans', 'Segoe UI', Arial, sans-serif;
}
.stats {
	color: white;
}
.stat-card {
	border-radius: 2rem;
	padding: 2.2rem 1.7rem 1.7rem 1.7rem;
	color: #fff;
	box-shadow: 0 4px 24px 0 rgba(0,0,0,0.18), 0 1.5px 4px 0 rgba(0,0,0,0.12);
	text-align: center;
	font-size: 1.25rem;
	margin-bottom: 1.5rem;
	border: 1.5px solid #222d32;
	transition: transform 0.1s;
}
.stat-card:hover {
	transform: translateY(-2px) scale(1.03);
	box-shadow: 0 8px 32px 0 rgba(0,0,0,0.22), 0 2px 8px 0 rgba(0,0,0,0.14);
}
.stat-label {
	font-size: 1.05rem;
	opacity: 0.85;
	margin-bottom: 0.2rem;
	letter-spacing: 0.5px;
}
.stat-value {
	font-size: 2.3rem;
	font-weight: 700;
	margin-top: 0.1rem;
	letter-spacing: 0.5px;
}

.bg-primary { background: #375a7f !important; }
.bg-success { background: #00bc8c !important; }
.bg-warning { background: #f39c12 !important; color: #232a2f !important; }
.bg-danger { background: #e74c3c !important; }
.bg-info { background: #3498db !important; }
.bg-secondary { background: #7b8a8b !important; }
.card {
	background: #263238;
	border-radius: 0.75rem;
	border: 1.5px solid #232a2f;
	color: #e5e5e5;
	box-shadow: 0 4px 24px 0 rgba(0,0,0,0.18), 0 1.5px 4px 0 rgba(0,0,0,0.12);
}
.display-4 {
	font-size: 2.7rem;
	font-weight: 700;
}
h2, h5 {
	color: #dbdbdb;
	font-weight: 600;
	letter-spacing: 0.5px;
}
th {
	color: #f39c12 !important;
	font-weight: 500;
	background: transparent !important;
}
td {
	color: #e5e5e5 !important;
	background: transparent !important;
}
.table {
	margin-bottom: 0;
}
.b-navbar, .submenu {
	background: #263238 !important;
	b--order-bottom: 2px solid #00bc8c;
}
.b-navbar-brand {
	color: #00bc8c !important;
	font-weight: 700;
	font-size: 1.3rem;
	letter-spacing: 1px;
}
.b-navbar-nav a {
	color: #f39c12 !important;
	font-weight: 500;
	margin-left: 1rem;
}
.b-navbar-nav a:hover {
	color: #fff !important;
	text-decoration: underline;
}

</style>

<style >
.text-info {
	color: #00a2ff !important;
}
.text-mark {
	padding-top: 10px;
	color: #00a2ff !important;
	padding-bottom: 10px;
	display: block;
	text-align: center;
	background: repeating-linear-gradient(
		135deg,
		#232a2f,
		#232a2f 10px,
		#263238 10px,
		#263238 20px
	);
	margin-top: 5px;
	margin-bottom: 5px;
}
.text-success, .text-hit {
	color: #00ff0d !important;
	font-weight: bold;
}

.text-danger {
	color: #e74c3c !important;
	font-weight: bold;
}
.text-del {
	color: #ff0000 !important;
	font-weight: bold;
}
.text-exception {
	color: #ff0000 !important;
	font-weight: bold;
	animation: flash 1s linear 10;
	}

	@keyframes flash {
		0%, 100% { opacity: 1; }
		50% { opacity: 0.2; }
}
.text-warning {
	color: #f39c12 !important;
	font-weight: bold;
}
.text-muted2 {
	color: #dedede !important;
}
.text-orange {
	color: #ff8c00 !important;
	font-weight: bold;
}
.text-queue {
	color: #edc917 !important;
	font-weight: bold;
}
.text-process {
	color: #00ff0d !important;
	font-weight: bold;
}
.text-remoteinfo {
	color: #bfbfbf79 !important;
}
</style>
